export default { 1: "Пригородный", 2: "Городской", 3: "Комфортный" };
